export const LINKS = {
  FAQ: "/#landing_faq_section",
};
